import { clsx } from 'clsx';

type ProgressType = Array<{
  title: string;
  percentage: number;
  isActive: boolean;
}>;

export const ProgressIndicator = ({
  progress,
  className,
}: {
  progress: ProgressType;
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        'mx-auto mb-xl mt-l flex w-full max-w-[600px] gap-xs px-s m800:my-2xl',
        className,
      )}
    >
      {progress.map(({ title, percentage, isActive }) => {
        return (
          <div key={title} className="w-full">
            <div className="relative mb-s h-xs w-full bg-secondary-90">
              <div
                className="absolute inset-y-0 left-0 bg-primary-10"
                style={{ width: `${percentage}%` }}
              />
            </div>
            <div
              className={clsx(
                'text-xs font-med',
                isActive ? 'text-primary-10' : 'text-secondary-40',
              )}
            >
              {title}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const SECTION_TO_TITLE_MAPPING = {
  details: 'Details',
  choose_product: 'Choose product',
  fraud: 'Security checks',
  offer: 'Offer',
  completed: 'Completed',
} as const;
